/**
 * @module FlowHelpers
 * @description Helper functions for flows which are used to convert data between frontend and backend format.
 */

/**
 * Find a flow by its id in a list of flows from the backend formated data
 * 
 * TODO refactor this to have targetBlock, previousBlock and parentBlock as the return value
 */
function findFlowById(flows, id) {
  let result = {
    previousBlock: null,
    parentBlock: null,
    index: null,
  };
  flows.every((flow, index) => {
    if (flow.block_id === id) {
      result = {
        previousBlock: flow,
        parentBlock: flows,
        index,
      };
      return false;
    }
    if (flow.child_flows) {
      flow.child_flows.every((childFlow) => {
        const childCheck = findFlowById(childFlow.blocks, id);
        if (childCheck.previousBlock && childCheck.parentBlock && childCheck.index !== null) {
          result = childCheck;
          return false;
        }
        return true;
      });
    }
    if (result.previousBlock && result.parentBlock && result.index !== null) {
      return false;
    }
    return true;
  });
  return result;
}

function parseBackendStructureToFrontendStructure() {}

function parseFrontendStructureToBackendStructure(frontendStructure, backendStructure = []) {
  return backendStructure;
}

export {
  findFlowById,
  parseBackendStructureToFrontendStructure,
  parseFrontendStructureToBackendStructure,
};
